import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Image as AtomicImage } from '@thd-olt-component-react/image';
import './EtchVisualNav3AcrossMobile.scss';

const EtchVisualNav3AcrossMobile = (props) => {
  const { opts = {} } = props;
  const {
    id,
    links = [],
    type
  } = opts;

  return (
    <div className="EtchVisualNav3AcrossMobile" id={id} type={type}>
      <nav className="visualNav__container-sm">
        { links.map(({ image = {}, link, linkText }) => (
          <div className="visualNav" key={`${link}_${id}`} link-id={id}>
            {link
            && (
              <>
                <a href={link}>
                  <AtomicImage
                    src={image.src}
                    className="visualNav__img"
                    alt={image.alt}
                    lazy
                  />
                </a>
                <a href={link} className="visualNav__title-center">{linkText}</a>
              </>
            )}
            {!link
            && (
              <>
                <AtomicImage
                  src={image.src}
                  className="visualNav__img"
                  alt={image.alt}
                  lazy
                />
                <p className="visualNav__title-center">{linkText}</p>
              </>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
};

EtchVisualNav3AcrossMobile.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    parentId: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      linkText: PropTypes.string,
      image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
      })
    })),
    type: PropTypes.string
  }).isRequired
};
EtchVisualNav3AcrossMobile.defaultProps = {
};

export default EtchVisualNav3AcrossMobile;
